<template>
	<div class="user">
		<button v-if="!isUserAuthenticated" @click="login()">Sign In</button>
		<div v-else>
			<img :src="getUserPhoto" />
			<button @click="download()">Download</button>
			<button @click="uploadClick">Upload</button>
			<button @click="logout()">Logout</button>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	computed: mapGetters(['getUserPhoto', 'isUserAuthenticated']),
	methods: {
		...mapActions(['login', 'logout', 'download', 'upload']),
		uploadFile: async function (evt) {
			if (evt.target.files.length !== 1) return;

			const file = evt.target.files[0];
			this.upload(file);
		},
		uploadClick: function () {
			const input = document.createElement('input');
			input.type = 'file';
			input.addEventListener('change', this.uploadFile);
			input.click();
		},
	},
};
</script>

<style lang="scss">
.user {
	text-align: center;

	img {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		background: var(--color-beige-lighter);
		vertical-align: middle;
	}
}
</style>
